/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import AnalyticsService from 'cio/services/analytics';

interface IntegrationsNotifyWhenAvailableArgs {
  ctaHref?: string;
  ctaText?: string;
  new?: boolean;
  category?: string;
  name?: string;
  type?: string;
  onClose?: () => unknown;
  public?: boolean;
}

export default class IntegrationsNotifyWhenAvailable extends Component<IntegrationsNotifyWhenAvailableArgs> {
  @service analytics!: AnalyticsService;

  get ctaHref() {
    return this.args.ctaHref ?? '#';
  }
  get ctaText() {
    return this.args.ctaText ?? 'Schedule a call';
  }
  get new() {
    return this.args.new ?? false;
  }
  get category() {
    return this.args.category ?? '';
  }
  get name() {
    return this.args.name ?? '';
  }
  get type() {
    return this.args.type ?? '';
  }
  get onClose() {
    return this.args.onClose ?? (() => {});
  }
  get public() {
    return this.args.public ?? false;
  }

  get from() {
    return this.public ? 'Public' : 'In-App';
  }

  @action
  onSchedule() {
    let { from, type, name, category } = this;
    let trackData: Record<string, string> = {
      from,
      requestType: 'Existing',
      type,
      name,
      category,
    };

    this.analytics.track('integration', 'request_scheduling_started', trackData);

    this.onClose();
  }
}
